import type { Account } from '@api/hooks/useAccounts';
import { useCustomerAccount } from '@api/hooks/useCustomerAccount';
import { DEFAULT_PAGE_SIZE } from '@gurupay/gp-ui-library';

import { usePagination } from './usePagination';

interface PaginatedAccounts {
	limit?: number;
	isFull?: boolean;
}

export interface PaginatedAccountsResult {
	currentPage: number;
	onPageChange: (page: number) => void;
	pageSize: number;
	onPageSizeChange: (pageSize: number) => void;
	totalCount: number;
	pageOptions: { label: string; value: number }[];
	pageText: string;
	totalCountText: string;
}

export const usePaginatedAccounts = ({
	limit = DEFAULT_PAGE_SIZE,
	isFull = false,
}: PaginatedAccounts = {}): {
	pagination: PaginatedAccountsResult;
	accounts: Account[];
	isLoading: boolean;
	isError: boolean;
} => {
	const {
		currentPage,
		setCurrentPage,
		pageSize,
		handlePageSizeChange,
		pageOptions,
		pageText,
		totalCountText,
	} = usePagination(limit);

	const { data, isLoading, isError } = useCustomerAccount({
		currentPage,
		limit: pageSize,
		isFull,
	});

	const pagination: PaginatedAccountsResult = {
		currentPage,
		onPageChange: setCurrentPage,
		pageSize,
		onPageSizeChange: handlePageSizeChange,
		totalCount: data?.pagination?.count ?? 0,
		pageOptions,
		pageText,
		totalCountText,
	};

	return {
		pagination,
		accounts: data?.items ?? [],
		isLoading,
		isError,
	};
};
